import React, { Component } from 'react';
import {Paper, Grid, Typography, Button, TextField, IconButton} from '@material-ui/core';
import * as Gserv from '../services/GatewayService';
// import Settings from '@material-ui/icons/Settings';
import DatasheetView from './DatasheetView';
import InputField from './InputField';
import DatePicker from './DatePicker';
import DropDown from './DropDown';
import Toggle from './Toggle';
// import { AssessmentTwoTone } from '@material-ui/icons';
// import * as Calc from '../services/CalcService';
import moment from 'moment';
import { LockOpenTwoTone, MoveToInboxTwoTone } from '@material-ui/icons';
import AlertDialog from './AlertDialogue';


export default class Employees extends Component {

    constructor(props) {
        super(props);
        this.reset_state = {
            empl_num_error: null,
            empl_num_input: '',
            name_error: null,
            name_input: '',
            can_submit: true,
            writing: false,
            deleting: false,
            editing: false,
            error: false,
            error_message: '',
            querying: true,
            search_name: '',
            search_number: '',
            search_branch: '',
            search_rom: '',
            has_searched: false,
            users_array: [],
            show_dialogue: false,
            dialogue_parms: {},
            record_to_archive: {},
            form_view: false,
            form_data: {},
            current_record: {},
            primary_button_enabled: false,
            primary_button_text: 'Create Employee',
            id_validation: false,
            id_validation_gender: '',
            write_successful: false,
            write_success_message: '',
        }
        this.state = {  //Note: designations not reset
            empl_num_error: null,
            empl_num_input: '',
            name_error: null,
            name_input: '',
            can_submit: true,
            writing: false,
            deleting: false,
            editing: false,
            designations: [],
            error: false,
            error_message: '',
            querying: true,
            search_name: '',
            search_number: '',
            search_branch: '',
            search_rom: '',
            has_searched: false,
            users_array: [],
            show_dialogue: false,
            dialogue_parms: {},
            record_to_archive: {},
            form_view: false,
            form_data: {},
            current_record: {},
            primary_button_enabled: false,
            primary_button_text: 'Create Employee',
            include_terminated_users: false,
            id_validation: false,
            id_validation_gender: '',
            write_successful: false,
            write_success_message: '',
        };
        this.datasheetFieldSpecs = [
            { field: 'employee_number', headerName: 'Empl.#', width: 110, align:'center',headerAlign:'center'},     
            { field: 'name', headerName: 'Employee', width: 180},
            { field: 'id', headerName: 'ID Number', width: 130},
            { field: 'gender', headerName: 'Gender', width: 110, align:'center',headerAlign:'center'},
            { field: 'race', headerName: 'Race', width: 110, align:'center',headerAlign:'center'},
            { field: 'job_title', headerName: 'Job Title', width: 160},
            { field: 'date_of_entry', headerName: 'DOE', width: 120},
            { field: 'p_p', headerName: 'P/P', width: 100, align:'center',headerAlign:'center'},
            { field: 'store_code', headerName: 'Branch', width: 110, align:'center',headerAlign:'center'},
            { field: 'reports_to_rom', headerName: 'Manager Code', align: 'center',width: 125},
            { field: 'store', headerName: 'Store', width: 160},
            { field: 'region', headerName: 'Region', width: 150},
            { field: 'registered', headerName: 'Registered?', width: 110, align:'center',headerAlign:'center'},
            { field: 'reset', headerName: 'Reset Registration', width: 73, headerAlign: 'center',
            sortable: false,
            renderCell: (parms) => {
                if (parms.row.registered==='YES'){
                return (<IconButton
                    onClick={()=>this.resetPassword(parms)} 
                >
                    <LockOpenTwoTone />
                </IconButton>
                )}
            }},
            { field: 'is_a_rom', headerName: 'Manager?', width: 110, align:'center',headerAlign:'center'},
            { field: 'is_an_exec', headerName: 'Exec?', width: 110, align:'center',headerAlign:'center'},
            { field: 'grade', headerName: 'Grade', width: 110, align:'center',headerAlign:'center'},
            { field: 'succession_flag', headerName: 'Succession Flag?', width: 110, align:'center',headerAlign:'center'},
            { field: 'formally_trained', headerName: 'Formally Trained?', width: 110, align:'center',headerAlign:'center'},
            { field: 'terminated', headerName: 'Terminated?', width: 110, align:'center',headerAlign:'center'},
            { field: 'email', headerName: 'Email', width: 200},
            { field: 'archive', headerName: 'Archive', width: 73, headerAlign: 'center',
            sortable: false,
            renderCell: (parms) => {
                if (parms.row.archived==='NO'){
                return (<IconButton
                    onClick={()=>this.archiveDialogue(parms)} 
                >
                    <MoveToInboxTwoTone />
                </IconButton>
                )}
            }}
        ]

        this.input_fieldSpecs = [

            {field: "name", headerName: "Employee Name (SURNAME INITIALS)", f_inputType:'text', f_show:true, f_required:true,  f_minLength: 4, f_maxLength: 100, f_upperCase:true},

            {field: "employee_number", headerName: "Employee Number", f_inputType:'text', f_show:true, f_required:true,  f_minLength: 1, f_maxLength: 10,f_upperCase:true},

            {field: "id", headerName: "ID Number", f_inputType:'text', f_show:true, f_required:true,  f_minLength: 4, f_maxLength: 20, f_upperCase:true},

            {field: "gender", headerName: "Gender", f_inputType:'dropdown', f_show:true, f_required:true},

            {field: "race", headerName: "Race", f_inputType:'dropdown', f_show:true, f_required:true},

            {field: "job_title", headerName: "Job Title", f_inputType:'text', f_show:true, f_required:true,  f_minLength: 4, f_maxLength: 50, f_upperCase:true},

            {field: "date_of_entry", headerName: "Date of Entry?", f_inputType:'datepicker', f_required:true, f_show:true},

            {field: "p_p", headerName: "P/P", f_inputType:'text', f_show:true, f_required:true,  f_minLength: 2, f_maxLength: 4, f_upperCase:true},

            {field: "store_code", headerName: "Branch Code", f_inputType:'text', f_show:true, f_required:true,  f_minLength: 2, f_maxLength: 4, f_upperCase:true},

            {field: "reports_to_rom", headerName: "Manager Code", f_inputType:'text', f_show:true, f_required:true,  f_minLength: 2, f_maxLength: 5, f_upperCase:true},

            {field: "store", headerName: "Store", f_inputType:'text', f_show:true, f_required:false,  f_minLength: 4, f_maxLength: 100, f_upperCase:true},

            {field: "region", headerName: "Region", f_inputType:'text', f_show:true, f_required:true,  f_minLength: 2, f_maxLength: 45, f_upperCase:true},
           
            {field: "is_exec", headerName: "Executive?", f_inputType:'toggle', f_true_tag:'Yes', f_false_tag:'No', f_show:true},
     
            {field: "grade", headerName: "Grade", f_inputType:'text', f_show:true, f_required:false,  f_minLength: 1, f_maxLength: 10, f_upperCase:true},
     
            {field: "latest_sop_result", headerName: "Latest S.O.P. Result", f_inputType:'number', f_show:true, f_required:false,  f_minLength: 1, f_maxLength: 5, f_upperCase:true},
     
            {field: "formally_trained", headerName: "Formally Trained?", f_inputType:'toggle', f_true_tag:'Yes', f_false_tag:'No', f_show:true},
     
            {field: "succession_flag", headerName: "Succession Flag?", f_inputType:'toggle', f_true_tag:'Yes', f_false_tag:'No', f_show:true},

            {field: "employment_terminated", headerName: "Terminated?", f_inputType:'toggle', f_true_tag:'Yes', f_false_tag:'No', f_show:true},

        ]

        this.genders = [{id:'M',gender:'Male'},{id:'F',gender:'Female'}]
        this.races = [{id:'A',race:'African'},{id:'C',race:'Coloured'},{id:'I',race:'Indian'},{id:'W',race:'White'}]

        this.Today = new Date();

    }

    componentDidMount = () => {
        // if (this.state.search_name||this.state.search_number||this.state.search_branch||this.state.search_rom){
        //     this.runSearch();
        // }
    };

    runSearch = (e) => {

        if (e){e.preventDefault()};
        // console.log('e :>> ', e);

        if (!this.state.search_name&&!this.state.search_number&&!this.state.search_branch&&!this.state.search_rom){return}

        this.setState({searching:true, querying:true, search_ready:false,users_array:[], has_searched:true});

        var params = {search_string: this.state.search_name, search_type:'surname', incl_terminated: this.state.include_terminated_users};
        if (this.state.search_number){params={search_string: this.state.search_number, search_type:'employee number', incl_terminated: this.state.include_terminated_users}}
        if (this.state.search_branch){params={search_string: this.state.search_branch, search_type:'branch', incl_terminated: this.state.include_terminated_users}}
        if (this.state.search_rom){params={search_string: this.state.search_rom, search_type:'rom', incl_terminated: this.state.include_terminated_users}}

        Gserv.sendCommand('find_users_for_maintenance',this.props.gwt,params)
        .then(reply => {
            console.log('search reply :>> ', reply);
            if (reply.error){
                console.log('error on return from Gserv (find_users_for_maintenance) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us."});
            } else if (reply.Result!=="Success"&&reply.statusCode!==204){
                console.log('error on return from Gserv (find_users_for_maintenance) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us."});
            } else if (reply.Result!=="Success"){
                //not broken, but for some reason couldn't update / add record
                if (reply.statusCode===204){
                    this.setState({error:true,error_message:"No employee records found matching the search.",searching:false, has_searched:false});
                } else {
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us."})
                }
            } else {
                if (reply.Records){
                    let record_array = reply.Records;
                    let DOE = null;
                    for (var i=0;i<record_array.length;i++){
                        DOE = new moment(record_array[i].date_of_entry).format("YYYY-MM-DD");
                        record_array[i].date_of_entry = DOE;
                    }
                }
                this.setState({users_array:reply.Records,searching:false,search_ready:true, querying:false});
            }
        });
    }

    handleChildStateUpdate = (new_state) => {
        this.setState(new_state);
    }

    editAssessments = (parms) => {
        // console.log('edit assessments with parms :>> ', parms);
        this.setState({current_record:parms.row,assessments_view:true});
    }

    processForm = (e) => {
        e.preventDefault();
        // console.log('this.state.form_data :>> ', this.state.form_data);
        this.setState({writing:true, primary_button_enabled:false});
        //set state updating here...
        
        if (this.state.current_record.id){
            //this is an update

            Gserv.sendCommand('update_user',this.props.gwt,{
                form_data : this.state.form_data,
                id : this.state.current_record.id
            })
            .then(reply => {
                // console.log('update reply :>> ', reply);
                if (reply.error){
                    console.log('error on return from Gserv (update_user) :>> ', reply);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                } else if (reply.statusCode===409) {
                    console.log('error on return from Gserv (update_user) :>> ', reply);
                    this.setState({error:true,error_message:"Unable to create employee : An employee with this code or name already exists.",querying:false});
                } else if (reply.Message.includes("gender mismatch")){
                    console.log('error on return from Gserv (update_user) :>> ', reply);
                    this.setState({error:true,error_message:"Unable to create employee : The selected gender doesn't match the ID number provided.",querying:false});
                } else if (reply.Message.includes("invalid name format")){
                    console.log('error on return from Gserv (update_user) :>> ', reply);
                    this.setState({error:true,error_message:"Unable to create employee : The name format provided is invalid - please fill in the name as : SURNAME AA (where AA are initials).",querying:false});
                } else if (reply.Result!=="Success") {
                    console.log('error on return from Gserv (update_user) :>> ', reply);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                } else {
                    this.setState({write_successful:true,write_success_message:'Employee Record Updated Successfully.'});
                }
            });           

        } else {
            //this is a create
            Gserv.sendCommand('create_user',this.props.gwt,{
                form_data : this.state.form_data
            })
            .then(reply => {
                // console.log('create reply :>> ', reply);
                if (reply.error){
                    console.log('error on return from Gserv (create_user) :>> ', reply);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                } else if (reply.statusCode===409){
                    console.log('error on return from Gserv (create_user) :>> ', reply);
                    this.setState({error:true,error_message:"Unable to create employee : An employee with either this employee number or this ID number already exists.",querying:false});
                } else if (reply.Message.includes("gender mismatch")){
                    console.log('error on return from Gserv (update_user) :>> ', reply);
                    this.setState({error:true,error_message:"Unable to create employee : The selected gender doesn't match the ID number provided.",querying:false});
                } else if (reply.Message.includes("invalid name format")){
                    console.log('error on return from Gserv (update_user) :>> ', reply);
                    this.setState({error:true,error_message:"Unable to create employee : The name format provided is invalid - please fill in the name as : SURNAME AA (where AA are initials).",querying:false});
                } else if (reply.Result!=="Success"){
                    console.log('error on return from Gserv (create_user) :>> ', reply);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                } else {
                    this.setState({write_successful:true,write_success_message:'Employee Record Created Successfully.'});
                }
            });
        }
    }

    handleFieldUpdate = (fieldObj) => {
        // console.log('called field update...');
        // console.log('child field update:',fieldObj);
        // console.log(this.state.current_record);
        // eslint-disable-next-line eqeqeq
        if (fieldObj.value==''){fieldObj.value=null}
        let myFormData = this.state.form_data;
        myFormData[fieldObj.field] = fieldObj.value;
        this.setState({form_data:myFormData});

        //validate id number if changed and potentially a valid SA ID...
        if (fieldObj.field==='id'&&fieldObj.value){
            if (fieldObj.value.length===13&&!isNaN(fieldObj.value)){
                const id_validation_obj = this.parseID(fieldObj.value);
                // console.log('id_validation_obj :>> ', id_validation_obj);
                if (id_validation_obj.Result!=="Success"){
                    this.setState({id_validation:false});
                } else{
                    this.setState({id_validation:true, id_validation_gender:id_validation_obj.gender});
                }
            } else {
                this.setState({id_validation:false});
            }
        }

        // eslint-disable-next-line eqeqeq
        if(this.state.current_record[fieldObj.field]!=fieldObj.value){
            const truthyCurrentRec = this.state.current_record[fieldObj.field]? true : false;
            const truthyFieldObj = fieldObj.value ? true : false;
            //exclude nulls vs '' vs false etc.
            if (truthyCurrentRec||truthyFieldObj){
                // console.log('found update...');
                this.setState({primary_button_enabled:true});
            }
        } 
    }

    handleUpdate = (record) => {
        // console.log('record for update :>> ', record);
        
        //Translate switches to boolean...
        let current_rec = record.row;
        current_rec.is_exec = record.row.is_an_exec==="YES"? true : false;
        current_rec.employment_terminated = record.row.terminated==="YES"? true : false;
        current_rec.formally_trained = record.row.formally_trained==="YES"? true : false;
        current_rec.succession_flag = record.row.succession_flag==="YES"? true : false;

        this.setState({current_record:record.row,form_view:true,editing:true,primary_button_enabled:false,primary_button_text:'Update Employee Record'});
    }

    handleDelete = (record) => {
        // console.log('record for delete :>> ', record);

        // this.setState({show_dialogue:true});
        //Hide just while testing modal...
        this.setState({deleting:true,querying:true});
        Gserv.sendCommand('delete_user',this.props.gwt,{
            id: record.id
        })
        .then(reply => {
            // console.log('delete reply :>> ', reply);
            if (reply.error){
                console.log('error on return from Gserv (delete_user) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else if (reply.Result==="Failed"&&reply.Message.includes('FOREIGN KEY')){
                console.log('error on return from Gserv (delete_user) :>> ', reply);
                this.setState({error:true,error_message:"Unable to delete employee : There is data on file already for this employee (such as assessments or nominations) and the employee record can therefore not be deleted.",querying:false});
            } else if (reply.Result!=="Success"){
                console.log('error on return from Gserv (delete_user) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else {
                this.setState({deleting:false});
                this.runSearch();
            }
        });

    }
    
    handleToggleChange = (e) => {
        // console.log('e :>> ', e);
        switch (e.field) {
            case 'include_terminated_users':
                this.setState({include_terminated_users:e.value});
                // if (this.state.search_ready){
                    // this.runSearch();
                // }
                break;
        
            default:
                break;
        }
    }

    parseID = (idNumber) => {
    
        //Kill at source if not 13 digits or not all numbers...
        if (idNumber.length !== 13 || isNaN(idNumber)){
            return {Result : "Failed"};
        }

        // assume everything is correct and if it later turns out not to be, set this to false
        var correct = true;
        var idParse = {};
    
        // get first 6 digits as a valid date
        var tempDate = new Date(idNumber.substring(0, 2), idNumber.substring(2, 4)-1, idNumber.substring(4, 6));
        var id_date = tempDate.getDate();
        var id_month = tempDate.getMonth();
      
        var id_year = tempDate.getFullYear();
        const thisYear = this.Today.getFullYear();
    
        if((thisYear - id_year)>=100){
          tempDate.setFullYear(tempDate.getFullYear()+100);
          id_year = tempDate.getFullYear()
        }
    
        // eslint-disable-next-line eqeqeq
        if (!((tempDate.getFullYear().toString().substring(2,4) == idNumber.substring(0, 2)) && (id_month == idNumber.substring(2, 4) - 1) && (id_date == idNumber.substring(4, 6)))) {
            // console.log('Date failed');
            correct = false;
        }
    
        // get the gender
        var genderCode = idNumber.substring(6, 10);
        var gender = parseInt(genderCode) < 5000 ? "F" : "M";
    
        // get country ID for citzenship
        var citzenship = parseInt(idNumber.substring(10, 11)) === 0 ? "Yes" : "No";
    
        // apply Luhn formula for check-digits
        var tempTotal = 0;
        var checkSum = 0;
        var multiplier = 1;
        for (var i = 0; i < 13; ++i) {
            tempTotal = parseInt(idNumber.charAt(i)) * multiplier;
            if (tempTotal > 9) {
                tempTotal = parseInt(tempTotal.toString().charAt(0)) + parseInt(tempTotal.toString().charAt(1));
            }
            checkSum = checkSum + tempTotal;
            multiplier = (multiplier % 2 === 0) ? 1 : 2;
        }
        if ((checkSum % 10) !== 0) {
            correct = false;
        };
    
        //advance DOB by 12 hours to eliminate issue with timezones...
        tempDate.setHours(tempDate.getHours()+12);
    
        // if no error found, hide the error message
        if (correct) {
            idParse = {
              id_number : idNumber,
              Result : "Success",
              date_of_birth : tempDate,
              gender : gender,
              sa_citizen : citzenship
            };
        }
        // otherwise, show the error
        else {
            idParse = {
              Result : "Failed"        
            };
        }
        return idParse;
    }

    resetMe = () => {
        this.setState(this.reset_state);
    }

    editAgain = () => {
        this.setState({error:false,error_message:'',writing:false,});
    }

    resetPassword = (parms) => {
        // console.log('parms :>> ', parms);
        if (window.confirm("This function will reset " + parms.row.name + "'s this users registration - they will need to sign in again and re-register. Are you sure you wish to proceed?")){
            // console.log('Proceed with reset...');
            this.setState({writing:true, primary_button_enabled:false});

            Gserv.sendCommand('reset_user_reg',this.props.gwt,{
                id : parms.row.employee_number
            })
            .then(reply => {
                // console.log('update reply :>> ', reply);
                if (reply.error){
                    console.log('error on return from Gserv (reset_user_reg) :>> ', reply);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                } else if (reply.statusCode===409) {
                    console.log('error on return from Gserv (reset_user_reg) :>> ', reply);
                    this.setState({error:true,error_message:"Unable to create employee : An employee with this code or name already exists.",querying:false});
                } else if (reply.Message.includes("gender mismatch")){
                    console.log('error on return from Gserv (reset_user_reg) :>> ', reply);
                    this.setState({error:true,error_message:"Unable to create employee : The selected gender doesn't match the ID number provided.",querying:false});
                } else if (reply.Message.includes("invalid name format")){
                    console.log('error on return from Gserv (reset_user_reg) :>> ', reply);
                    this.setState({error:true,error_message:"Unable to create employee : The name format provided is invalid - please fill in the name as : SURNAME AA (where AA are initials).",querying:false});
                } else if (reply.Result!=="Success") {
                    console.log('error on return from Gserv (reset_user_reg) :>> ', reply);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                } else {
                    alert(parms.row.name + "'s registration has been successfully reset.");
                    this.setState(this.reset_state);
                }
            });           
        } 
    }

    archiveDialogue = (parms) => {
        // console.log('parms :>> ', parms.row);
        this.setState({show_dialogue:true, record_to_archive: parms.row, dialogue_parms: {
            title: 'Archive and Create Record with New Employee #?',
            description: 'This function will archive the current records of #' + parms.row.employee_number + ' ' + parms.row.name + ' - they will also be marked as terminated (if not already). A new employee record will then be created with a new / alternative Employee Number as specified below. This should only be done in cases where an employee needs to be re-employed with a different Employee Number. THIS CANNOT BE UNDONE. Are you sure you wish to proceed?'
        }});
    }

    dialogCallBack = (payload) => {
        // console.log('Callback payload :>> ', payload);
        this.setState({show_dialogue:false});
        if (payload.result === "YES"){
            this.archiveMe(payload.input_object.value);
        }
    }

    archiveMe = (new_number) => {

        this.setState({writing:true, primary_button_enabled:false});
        Gserv.sendCommand('archive_user_reg',this.props.gwt,{
            record_to_archive: this.state.record_to_archive,
            new_employee_number: new_number
        })
        .then(reply => {
            console.log('update reply :>> ', reply);
            if (reply.error){
                console.log('error on return from Gserv (archive_user_reg) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else if (reply.statusCode===409){
                console.log('error on return from Gserv (archive_user_reg) :>> ', reply);
                this.setState({error:true,error_message:"The new Employee Number specified is already in use. Please specify another new Employee Number.",querying:false});
            } else if (reply.Result!=="Success") {
                console.log('error on return from Gserv (archive_user_reg) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else {
                alert(this.state.record_to_archive.name + "'s records have been archived, and a new record has been created under Employee #" + new_number);
                this.setState(this.reset_state);
            }
        });           
    }

    render() {
        return (
            <Grid
                container
                direction='column'
                justifyContent='center'
                alignContent='center'
                // style={{backgroundColor:'yellow'}}
            >
                {!this.state.assessments_view&&
                <Grid item>
                <Paper
                    elevation={3}
                    style={{
                        // backgroundColor:'yellow',
                        // height:'22vh',
                        // maxWidth:680,
                        // minWidth:680
                        width:1250
                    }}
                >
                   <Typography
                    color='primary'
                    style={{paddingTop:15}}
                   >
                       Maintain Employees
                   </Typography>
                   <Grid
                    container
                    direction='row'
                    justifyContent='space-evenly'
                    alignContent='center'
                    style={{padding:15}}
                   >
                    {!this.state.form_view&&   
                    <Button
                        variant='contained'
                        color='primary'
                        type='submit'
                        onClick={()=>this.setState({form_view:true,primary_button_text:'Create Employee',error:false,error_message:'',current_record:{}})}
                        disabled={this.state.form_view||this.state.writing}
                    >
                        Create
                    </Button>}
                   </Grid>
                </Paper>
                </Grid>}

                {this.state.show_dialogue&&                        
                <AlertDialog
                    title={this.state.dialogue_parms.title}
                    description={this.state.dialogue_parms.description}
                    buttons={['YES','CANCEL']}
                    textInput={true}
                    fieldSpec={{
                        field: "employee_number",
                        headerName: "New Employee #",
                        f_inputType:'text',
                        f_show:true,
                        f_required:true,
                        f_minLength: 4,
                        f_maxLength: 10,
                        f_upperCase:true
                    }}
                    callBack={this.dialogCallBack}
                />}

                {/* {this.state.querying&&
                <Grid item>
                    <br/>
                    <Settings className='icn-spinner' /> Querying...
                </Grid>} */}

                {!this.state.form_view&&
                <form onSubmit={this.runSearch}>

                    <Grid 
                        container 
                        direction='row'
                        justifyContent='center'
                        alignItems='center'
                        style={{padding:'10px'}}
                    >

                        <TextField
                            id='surname'
                            autoComplete="off"
                            autoCorrect="off"
                            autoCapitalize="off"
                            autoFocus={true}
                            label={'Surname Search'}
                            variant='outlined'
                            value={this.state.search_name}
                            onChange={(e) => {
                                const outText = e.target.value.replace(/[^ A-Za-z]+/g, '').toUpperCase();
                                const can_sub = (outText.length>2);
                                this.setState({search_name: outText, search_number: '',search_branch:'', search_rom:'', search_ready: can_sub, error: false});
                            }}
                            // required
                            style={{marginBottom:'10px',marginTop:'15px'}}
                            disabled={this.state.searching||this.state.error}
                        />

                        <TextField
                            id='emplNum'
                            autoComplete="off"
                            autoCorrect="off"
                            autoCapitalize="off"
                            autoFocus={false}
                            label={'Employee # Search'}
                            variant='outlined'
                            value={this.state.search_number}
                            onChange={(e) => {
                                const outText = e.target.value.replace(/[^ A-Za-z0-9]+/g, '').toUpperCase();
                                const can_sub = (outText.length>0);
                                this.setState({search_number: outText, search_name:"", search_branch:"", search_rom:"", search_ready: can_sub, error: false});
                            }}
                            // required
                            style={{marginBottom:'10px', marginTop: '15px', marginLeft:'10px'}}
                            disabled={this.state.searching}
                        />

                        <TextField
                            id='branchCode'
                            autoComplete="off"
                            autoCorrect="off"
                            autoCapitalize="off"
                            autoFocus={false}
                            label={'Branch Code Search'}
                            variant='outlined'
                            value={this.state.search_branch}
                            onChange={(e) => {
                                const outText = e.target.value.replace(/[^A-Za-z]+/g, '').toUpperCase();
                                const can_sub = (outText.length>2);
                                this.setState({search_branch:outText, search_name: '', search_number: '', search_rom:'', search_ready: can_sub, error: false});
                            }}
                            // required
                            style={{marginBottom:'10px',marginTop:'15px', marginLeft:'10px'}}
                            disabled={this.state.searching||this.state.error}
                        />

                        <TextField
                            id='romCode'
                            autoComplete="off"
                            autoCorrect="off"
                            autoCapitalize="off"
                            autoFocus={false}
                            label={'Manager Code Search'}
                            variant='outlined'
                            value={this.state.search_rom}
                            onChange={(e) => {
                                const outText = e.target.value.replace(/[^A-Za-z]+/g, '').toUpperCase();
                                const can_sub = (outText.length>1);
                                this.setState({search_rom:outText, search_name: '', search_number: '', search_branch:'', search_ready: can_sub, error: false});
                            }}
                            // required
                            style={{marginBottom:'10px',marginTop:'15px', marginLeft:'10px'}}
                            disabled={this.state.searching||this.state.error}
                        />
                        &nbsp;&nbsp;&nbsp;    
                        <Toggle 
                            fieldMap={{field: "include_terminated_users", headerName: "Incl. Terminated Employees?", f_inputType:'toggle', f_true_tag:'Yes', f_false_tag:'No', f_show:true}} 
                            setField={this.handleToggleChange}
                            // disabled={}
                        />

                    </Grid>

                    <Button
                        variant='contained'
                        color='primary'
                        type='submit'
                        style={{marginLeft:'10px',marginBottom:'15px'}}
                        disabled={!this.state.search_ready||this.state.writing}
                    >
                        Search
                    </Button>

                </form>}

                {/* Datagrid goes here */}
                {!this.state.form_view&&this.state.has_searched&&
                <DatasheetView 
                    dataset={this.state.users_array}
                    fieldspecs={this.datasheetFieldSpecs}
                    delete={true}
                    edit={true}
                    handleDelete={this.handleDelete}
                    handleEdit={this.handleUpdate}
                    loading={this.state.querying}
                    deleteHeaderName={'Delete'}
                    pagesize={8}
                />}

                {this.state.error&&!this.state.form_view&&
                <div>
                    <Typography color='secondary' style={{Width:1250,maxWidth:1250, textAlign:'center',marginTop:15}}>{this.state.error_message}</Typography><br/>
                    <Button color='primary' variant='outlined' onClick={this.resetMe}>Reset</Button>
                </div>}

                {this.state.form_view&&
                <Paper
                    elevation={3}
                    style={{paddingBottom:'15px'}}
                >
                    <form onSubmit={this.processForm}>
                        <br/>
                        <Grid 
                            container 
                            direction='column'
                            alignItems='baseline'
                            justifyContent='center'
                            spacing={1}
                            style={{width:'100%', paddingLeft:'25%'}}
                        >

                            
                            {/* <InputField fieldMap={this.input_fieldSpecs[1]} setField={this.handleFieldUpdate} editRecord={this.state.current_record} disabled={this.state.writing}/> */}
                            
                            <div style={{width:'50%'}}>
                                <InputField fieldMap={this.input_fieldSpecs[0]} setField={this.handleFieldUpdate} editRecord={this.state.current_record} disabled={this.state.writing}/>
                            </div>

                            <div style={{width:'18%'}}>
                                <InputField fieldMap={this.input_fieldSpecs[1]} setField={this.handleFieldUpdate} editRecord={this.state.current_record} disabled={this.state.writing||this.state.editing}/>
                            </div>
                           
                            <div style={{width:'40%'}}>
                                <Grid container alignItems='center'>
                                    <InputField fieldMap={this.input_fieldSpecs[2]} setField={this.handleFieldUpdate} editRecord={this.state.current_record} disabled={this.state.writing||this.state.editing}/>
                                
                                    {this.state.form_data.id&&!this.state.id_validation&&
                                    <Typography color='secondary' style={{marginTop:15,marginLeft:10}}><small>Not a valid SA ID Number</small></Typography>}
                                </Grid>
                            </div>

                            <div style={{width:'40%'}}>
                                <Grid container direction='row' alignItems='center'>
                                    <div style={{width:'100px'}}>
                                        <DropDown fieldMap={this.input_fieldSpecs[3]} setField={this.handleFieldUpdate} editRecord={this.state.current_record} listArray={this.genders} disabled={this.state.writing} fullwidth={true}/>
                                    </div>

                                    {this.state.id_validation&&this.state.form_data.gender&&(this.state.id_validation_gender!==this.state.form_data.gender)&&
                                    <Typography color='secondary' style={{marginTop:15, marginLeft:10}}><small>Gender doesn't match SA ID</small></Typography>}
                                </Grid>
                            </div>

                            <div style={{width:'100px'}}>
                                <DropDown fieldMap={this.input_fieldSpecs[4]} setField={this.handleFieldUpdate} editRecord={this.state.current_record} listArray={this.races} disabled={this.state.writing} fullwidth={true}/>
                            </div>

                            <div style={{width:'30%'}}>
                                <InputField fieldMap={this.input_fieldSpecs[5]} setField={this.handleFieldUpdate} editRecord={this.state.current_record} disabled={this.state.writing}/>
                            </div>

                            <div style={{width:'20%'}}>
                                <DatePicker fieldMap={this.input_fieldSpecs[6]} setField={this.handleFieldUpdate} editRecord={this.state.current_record} disabled={this.state.writing}/>
                            </div>

                            <div style={{width:'15%'}}>
                                <InputField fieldMap={this.input_fieldSpecs[7]} setField={this.handleFieldUpdate} editRecord={this.state.current_record} disabled={this.state.writing}/>
                            </div>

                            <div style={{width:'15%'}}>
                                <InputField fieldMap={this.input_fieldSpecs[8]} setField={this.handleFieldUpdate} editRecord={this.state.current_record} disabled={this.state.writing}/>
                            </div>
                            
                            <div style={{width:'15%'}}>
                                <InputField fieldMap={this.input_fieldSpecs[9]} setField={this.handleFieldUpdate} editRecord={this.state.current_record} disabled={this.state.writing}/>
                            </div>

                            <div style={{width:'30%'}}>
                                <InputField fieldMap={this.input_fieldSpecs[10]} setField={this.handleFieldUpdate} editRecord={this.state.current_record} disabled={this.state.writing}/>
                            </div>

                            <div style={{width:'30%'}}>
                                <InputField fieldMap={this.input_fieldSpecs[11]} setField={this.handleFieldUpdate} editRecord={this.state.current_record} disabled={this.state.writing}/>
                            </div>

                            <div style={{paddingTop:'15px'}}>
                                <Toggle fieldMap={this.input_fieldSpecs[12]} setField={this.handleFieldUpdate} editRecord={this.state.current_record} disabled={this.state.writing}/>
                            </div>
                           
                            <div style={{width:'10%'}}>
                                <InputField fieldMap={this.input_fieldSpecs[13]} setField={this.handleFieldUpdate} editRecord={this.state.current_record} disabled={this.state.writing}/>
                            </div>
                           
                            <div style={{width:'15%', paddingTop:'10px'}}>
                                <InputField fieldMap={this.input_fieldSpecs[14]} setField={this.handleFieldUpdate} editRecord={this.state.current_record} disabled={this.state.writing}/>
                            </div>
                           
                            <div style={{paddingTop:'15px'}}>
                                <Toggle fieldMap={this.input_fieldSpecs[15]} setField={this.handleFieldUpdate} editRecord={this.state.current_record} disabled={this.state.writing}/>
                            </div>
                           
                            <div style={{paddingTop:'15px'}}>
                                <Toggle fieldMap={this.input_fieldSpecs[16]} setField={this.handleFieldUpdate} editRecord={this.state.current_record} disabled={this.state.writing}/>
                            </div>

                            <div style={{paddingTop:'10px'}}>
                                <Toggle fieldMap={this.input_fieldSpecs[17]} setField={this.handleFieldUpdate} editRecord={this.state.current_record} disabled={this.state.writing}/>
                            </div>
                     
                        </Grid>
                        <Button 
                            color='primary'
                            variant='outlined'
                            disabled={!this.state.primary_button_enabled}
                            type='submit'
                            style={{marginTop:'20px'}}
                        >
                            {this.state.primary_button_text}
                        </Button>
                        <Button 
                            type='button'
                            variant='outlined'
                            disabled={this.state.writing}
                            onClick={()=>this.setState({form_view:false, editing:false})}
                            style={{marginTop:'20px'}}
                        >
                            Cancel
                        </Button>
                    </form>

                    {this.state.error&&
                    <div>
                        <Typography color='secondary' style={{Width:1250,maxWidth:1250, textAlign:'center',marginTop:15}}>{this.state.error_message}</Typography><br/>
                        <Button color='primary' variant='outlined' onClick={this.editAgain}>Edit</Button>
                    </div>}

                    {this.state.write_successful&&
                    <div>
                        <Typography color='primary' style={{Width:1250,maxWidth:1250, textAlign:'center', marginTop:15}}>{this.state.write_success_message}</Typography><br/>
                        <Button color='primary' variant='outlined' onClick={this.resetMe}>Done</Button>
                    </div>}

                </Paper>}

            </Grid>
        );
    }
    
}